import styled from '@emotion/styled';

export const FormLabel = styled.label`
  white-space: nowrap;
  margin: 0;
  margin-bottom: 4px;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-size: 14px;
`;
